export default "__VITE_ASSET__$ty4IWAo__"